import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import {
  FDHeadlineText,
  FDLabelText,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('availableAmountToSaveTitle', {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, { ordinal: 200 })
  .nameOverride('availableAmountToSaveSubtitle', {
    _component: () => FDLabelText,
  }, { ordinal: 200 });

function AvailableAmountToSaveLayout() {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <FDStack direction="column" spacing={2}>
      <MetaControlField attr="availableAmountToSaveTitle" />
      <MetaControlField attr="availableAmountToSaveSubtitle" />
      <MetaControlField attr="availableAmountToSave" />
      {resource.meta().canSubmit() ? (
        <FDStack alignItems="center">
          <FDPrimaryActionButton
            test="facet-plan-save-available-resources"
            label="Save"
            loading={saving}
            onClick={async () => {
              logStandardizedEvent(categories.whatIf, eventTypes.changePicklist, 'set available resources', { eventProperties: { value: resource.attr('availableAmountToSave') } });
              await onSubmit();
            }}
          />
        </FDStack>
      ) : null}
    </FDStack>
  );
}

const AvailableAmountToSaveSection = ({
  resource,
}) => {
  const { refreshPageContentCollection } = usePageContentContext();
  const onSubmit = () => {
    refreshPageContentCollection();
  };

  if (!resource) {
    return null;
  }

  return (
    <MetaFormInline
      padding="none"
      noIndividualSubmitButtons
      layout={AvailableAmountToSaveLayout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
      onSubmit={onSubmit}
    />
  );
};

AvailableAmountToSaveSection.defaultProps = {};

AvailableAmountToSaveSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AvailableAmountToSaveSection;
